// Tools
import Vue from 'vue';
import Router from 'vue-router';
// Views
import ChatBot from './components/Chatbot.vue';

Vue.use(Router);

// Detect button back on browser
const popState = {
  detected: false,
};

window.addEventListener('popstate', () => {
  popState.detected = true;
});

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'start',
      beforeEnter(to, from, next) {
        const redirectHomeMarket = localStorage.getItem('homeMarket')
        && JSON.parse(localStorage.getItem('homeMarket')).parsedName
          ? JSON.parse(localStorage.getItem('homeMarket')).parsedName : 'chile';
        next({
          name: 'home',
          params: {
            homeMarket: redirectHomeMarket,
          },
          query: { token: to.params.id },
        });
      },
    },
    {
      path: '/',
      name: 'main',
      redirect: '/chile',
    },
    {
      path: '/chile',
      name: 'home',
      component: ChatBot,
      meta: {
        stayIfParams: true,
      },
    },
    {
      path: '/peru',
      name: 'peru',
      component: ChatBot,
      meta: {
        stayIfParams: true,
      },
    },
    {
      path: '/*',
      name: '404',
      component: ChatBot,
      redirect: '/chile'
    },
  ],
  // Function to scroll to top on change page
  scrollBehavior() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 500);
    });
  },
});

export default router;
